import LogsTab from './logsTab';

export default LogsTab;
